webpackJsonp([62066607354831],{

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Chinmaya
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CloseIcon = function (_React$Component) {
	  _inherits(CloseIcon, _React$Component);
	
	  function CloseIcon() {
	    _classCallCheck(this, CloseIcon);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  // constructor(){
	  //   super()
	  //   state = {
	  //     mouseOverFillColor: ""
	  //   }
	  // }
	
	  // onMouseOver = () => {
	  //   this.
	  // }
	
	  CloseIcon.prototype.render = function render() {
	    var _props = this.props,
	        width = _props.width,
	        height = _props.height,
	        fillColor = _props.fillColor,
	        className = _props.className;
	
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: width,
	        height: height,
	        viewBox: "0 0 14 14"
	      },
	      _react2.default.createElement(
	        "g",
	        { fill: "none", fillRule: "evenodd" },
	        _react2.default.createElement("path", { d: "M-5-5h24v24H-5z" }),
	        _react2.default.createElement("path", {
	          fill: fillColor,
	          d: "M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
	        })
	      )
	    );
	  };
	
	  return CloseIcon;
	}(_react2.default.Component);
	
	CloseIcon.defaultProps = {
	  width: 14,
	  height: 14,
	  fillColor: '#FFF'
	};
	
	exports.default = CloseIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Chinmaya
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var LeftArrow = function (_React$Component) {
	  _inherits(LeftArrow, _React$Component);
	
	  function LeftArrow() {
	    _classCallCheck(this, LeftArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  // constructor(){
	  //   super()
	  //   state = {
	  //     mouseOverFillColor: ""
	  //   }
	  // }
	
	  // onMouseOver = () => {
	  //   this.
	  // }
	
	  LeftArrow.prototype.render = function render() {
	    var _props = this.props,
	        width = _props.width,
	        height = _props.height,
	        fillColor = _props.fillColor,
	        className = _props.className;
	
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: width,
	        height: height,
	        viewBox: "0 0 18 12"
	      },
	      _react2.default.createElement(
	        "g",
	        { fill: "none", fillRule: "evenodd" },
	        _react2.default.createElement("path", { d: "M-3-6h24v24H-3z" }),
	        _react2.default.createElement("path", {
	          fill: fillColor,
	          d: "M18 5H3.83l3.58-3.59L6 0 0 6l6 6 1.41-1.41L3.83 7H18z"
	        })
	      )
	    );
	  };
	
	  return LeftArrow;
	}(_react2.default.Component);
	
	LeftArrow.defaultProps = {
	  width: 18,
	  height: 12,
	  fillColor: '#FFF'
	};
	
	exports.default = LeftArrow;
	module.exports = exports["default"];

/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Chinmaya
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var RightArrow = function (_React$Component) {
	  _inherits(RightArrow, _React$Component);
	
	  function RightArrow() {
	    _classCallCheck(this, RightArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  // constructor(){
	  //   super()
	  //   state = {
	  //     mouseOverFillColor: ""
	  //   }
	  // }
	
	  // onMouseOver = () => {
	  //   this.
	  // }
	
	  RightArrow.prototype.render = function render() {
	    var _props = this.props,
	        width = _props.width,
	        height = _props.height,
	        fillColor = _props.fillColor,
	        className = _props.className;
	
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: width,
	        height: height,
	        viewBox: "0 0 18 12"
	      },
	      _react2.default.createElement(
	        "g",
	        { fill: "none", fillRule: "evenodd" },
	        _react2.default.createElement("path", { d: "M21-6H-3v24h24z" }),
	        _react2.default.createElement("path", {
	          fill: fillColor,
	          d: "M0 5h14.17l-3.58-3.59L12 0l6 6-6 6-1.41-1.41L14.17 7H0z"
	        })
	      )
	    );
	  };
	
	  return RightArrow;
	}(_react2.default.Component);
	
	RightArrow.defaultProps = {
	  width: 18,
	  height: 12,
	  fillColor: '#FFF'
	};
	
	exports.default = RightArrow;
	module.exports = exports["default"];

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Lightbox = __webpack_require__(219);
	
	var _Lightbox2 = _interopRequireDefault(_Lightbox);
	
	var _CloudinaryS3Image = __webpack_require__(23);
	
	var _CloseIcon = __webpack_require__(1126);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _LeftArrow = __webpack_require__(1127);
	
	var _LeftArrow2 = _interopRequireDefault(_LeftArrow);
	
	var _RighttArrow = __webpack_require__(1128);
	
	var _RighttArrow2 = _interopRequireDefault(_RighttArrow);
	
	var _styledComponents = __webpack_require__(1130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryHome = function (_Component) {
	  _inherits(GalleryHome, _Component);
	
	  function GalleryHome() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GalleryHome);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      activeNodeId: 0
	    }, _this.onKeydown = function (e) {
	      var totalImagesData = _this.props.totalImagesData;
	
	
	      if (e.keyCode === 39) {
	        if (_this.state.activeNodeId < totalImagesData.length - 1) {
	          _this.gotoNext();
	        }
	      } else if (e.keyCode === 37) {
	        if (_this.state.activeNodeId > 0) {
	          _this.gotoPrevious();
	        }
	      } else if (e.keyCode === 27) {
	        _this.props.closeLightBox();
	      }
	    }, _this.gotoPrevious = function () {
	      var previousIndex = parseInt(_this.state.activeNodeId) - 1;
	      if (previousIndex < 0) {
	        previousIndex = 0;
	      }
	      _this.setState({
	        activeNodeId: previousIndex
	      });
	    }, _this.gotoNext = function () {
	      var totalImagesData = _this.props.totalImagesData;
	
	      var nextIndex = parseInt(_this.state.activeNodeId) + 1;
	      if (nextIndex === totalImagesData.length) {
	        nextIndex = 0;
	      }
	      _this.setState({
	        activeNodeId: nextIndex
	      });
	    }, _this.isMobileDevice = function () {
	      var isMobile = true;
	      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	        if (window.innerWidth > 767) {
	          isMobile = false;
	        }
	      }
	      return isMobile;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GalleryHome.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('keydown', this.onKeydown, false);
	  };
	
	  GalleryHome.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('keydown', this.onKeydown, false);
	  };
	
	  GalleryHome.prototype.componentWillMount = function componentWillMount() {
	    this.setState({ activeNodeId: this.props.currentImageData.imageId });
	  };
	
	  GalleryHome.prototype.render = function render() {
	    var _props = this.props,
	        totalImagesData = _props.totalImagesData,
	        closeLightBox = _props.closeLightBox,
	        date = _props.date;
	    var activeNodeId = this.state.activeNodeId;
	    var _totalImagesData$acti = totalImagesData[activeNodeId],
	        shortDescription = _totalImagesData$acti.shortDescription,
	        imageUrl = _totalImagesData$acti.imageUrl;
	
	
	    var isMobile = this.isMobileDevice();
	    var maxLength = totalImagesData.length;
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Lightbox2.default,
	        { isOpen: this.props.isLightBoxOpen },
	        _react2.default.createElement(
	          _styledComponents.GallerySection,
	          null,
	          _react2.default.createElement(
	            _styledComponents.GalleryHeader,
	            null,
	            activeNodeId > 0 ? _react2.default.createElement(
	              _styledComponents.GalleryNavigationContainerLeft,
	              { onClick: this.gotoPrevious },
	              _react2.default.createElement(_LeftArrow2.default, { width: '18', height: '12', fillColor: '#FFF' })
	            ) : null,
	            activeNodeId < maxLength - 1 ? _react2.default.createElement(
	              _styledComponents.GalleryNavigationContainerRight,
	              { onClick: this.gotoNext },
	              _react2.default.createElement(_RighttArrow2.default, { width: '18', height: '12', fillColor: '#FFF' })
	            ) : null,
	            _react2.default.createElement(
	              _styledComponents.GalleryCloseIconContainer,
	              { onClick: closeLightBox },
	              _react2.default.createElement(_CloseIcon2.default, { width: '14', height: '14', fillColor: '#FFF' })
	            )
	          ),
	          _react2.default.createElement(
	            _styledComponents.GalleryBody,
	            null,
	            ' ',
	            _react2.default.createElement(
	              'article',
	              {
	                className: '6u 12u$(xsmall) work-item',
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	                }
	              },
	              _react2.default.createElement(_CloudinaryS3Image.CloudinaryS3Image, {
	                configString: 'f_auto',
	                src: imageUrl,
	                style: {
	                  height: '50vh',
	                  maxWidth: '80%',
	                  objectFit: 'contain',
	                  draggable: 'false',
	                  marginTop: isMobile ? 0 : '50px'
	                }
	              })
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            _styledComponents.GalleryFooter,
	            null,
	            _react2.default.createElement(
	              _styledComponents.GalleryFooterDescription,
	              null,
	              shortDescription
	            ),
	            _react2.default.createElement(
	              _styledComponents.GalleryFooterDate,
	              null,
	              date
	            ),
	            _react2.default.createElement(_styledComponents.GalleryFooterHorizontalLine, null)
	          )
	        )
	      )
	    );
	  };
	
	  return GalleryHome;
	}(_react.Component);
	
	GalleryHome.displayName = 'Gallery';
	GalleryHome.propTypes = {
	  totalImagesData: _propTypes2.default.array
	};
	
	exports.default = GalleryHome;
	module.exports = exports['default'];

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ImageContainer = exports.GalleryNavigationContainerLeft = exports.GalleryNavigationContainerRight = exports.GalleryFooterHorizontalLine = exports.GalleryCloseIconContainer = exports.GalleryFooterDate = exports.GalleryFooterDescription = exports.FooterText = exports.GalleryFooter = exports.GalleryBody = exports.GalleryHeader = exports.GallerySection = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GallerySection = /*#__PURE__*/exports.GallerySection = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d0'
	})('display:flex;flex-direction:column;position:fixed;top:0;right:0;left:0;bottom:0;background:rgba(0,0,0,0.8);');
	
	var GalleryHeader = /*#__PURE__*/exports.GalleryHeader = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d1'
	})('width:100%;height:50px;display:flex;justify-content:flex-end;');
	
	var GalleryBody = /*#__PURE__*/exports.GalleryBody = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d2'
	})('height:100%;background-color:transparent;margin:20px 50px 10px 50px;display-flex;align-items:center;justify-content:center;@media (max-width:767px){margin:20px 20px 10px 20px;}');
	
	var GalleryFooter = /*#__PURE__*/exports.GalleryFooter = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d3'
	})('height:180px;display:flex;flex-direction:column;align-items:center;@media (max-width:767px){height:250px;}');
	
	var FooterText = /*#__PURE__*/exports.FooterText = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d4'
	})('display:flex;align-items:center;font-family:din-2014;color:#ffffff;font-style:normal;font-stretch:normal;letter-spacing:normal;text-align:center;font-size:1em;');
	
	var GalleryFooterDescription = /*#__PURE__*/exports.GalleryFooterDescription = (0, _reactEmotion2.default)(FooterText, {
	  target: 'e19gfi9d5'
	})('display:flex;justify-content:center;opacity:0.8;line-height:1.56;width:83%;');
	
	var GalleryFooterDate = /*#__PURE__*/exports.GalleryFooterDate = (0, _reactEmotion2.default)(FooterText, {
	  target: 'e19gfi9d6'
	})('opacity:0.7;font-size:0.875em;line-height:1.79;');
	
	var GalleryCloseIconContainer = /*#__PURE__*/exports.GalleryCloseIconContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d7'
	})('display:flex;align-items:center;margin-right:20px;margin-top:20px;cursor:pointer;width:24px;height:24px;cursor:pointer;object-fit:contain;&:hover{fill-color:white;}');
	
	var GalleryFooterHorizontalLine = /*#__PURE__*/exports.GalleryFooterHorizontalLine = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d8'
	})('width:83%;background-color:#ffffff;height:2px;opacity:0.5;margin-top:10px;');
	var GalleryNavigationContainerRight = /*#__PURE__*/exports.GalleryNavigationContainerRight = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d9'
	})('position:absolute;right:0;top:calc(50vh - 50px);width:1.5em;height:1.5em;margin-right:1.25em;object-fit:contain;cursor:pointer;@media (max-width:767px){top:calc(50vh - 75px);margin-right:0.5em;}');
	var GalleryNavigationContainerLeft = /*#__PURE__*/exports.GalleryNavigationContainerLeft = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d10'
	})('position:absolute;width:1.5em;height:1.5em;object-fit:contain;margin-left:1.25em;left:0;top:calc(50vh - 50px);cursor:pointer;@media (max-width:767px){top:calc(50vh - 75px);margin-left:0.5em;}');
	
	var ImageContainer = /*#__PURE__*/exports.ImageContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e19gfi9d11'
	})('display:flex;justify-content:center;align-items:center;');

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	// these sizes are arbitrary and you can set them to whatever you wish
	var defaulttheme = {
	  // Header landing section
	  headerTextColor: 'white',
	
	  // Button constants
	  buttonTextColor: 'white',
	  buttonBorderRadius: '4px',
	  filledButtonBGColor: '#19c7ff',
	  transparentButtonBGColor: 'rgba(255, 255, 255, 0.1)',
	  transparentButtonBorder: 'solid 1px rgba(255, 255, 255, 0.4);',
	
	  // darkBGColor: 'linear-gradient(#119ef7,#112e7e)',
	  navbar: {
	    lightBGColor: '#fffff',
	    darkBGColor: '#ffffff',
	    navTextColor: '#0a3981',
	    transparentNavTextColor: '#0a3981',
	    bgColor: '#fff',
	    transparentBGColor: 'transparent'
	  },
	  reachingWorldWide: {
	    headingColor: '#43484d',
	    subHeadingColor: '#5e6977',
	    descriptionColor: '#86939e',
	    applyColor: '#358ed7'
	  },
	  footerSection: {
	    background: '#122445',
	    inputBackground: 'rgba(255, 255, 255, 0.1)',
	    inputText: '#ffffff',
	    lightTextColor: '#ffffff',
	    filledButtonBGColor: '#19c7ff',
	    pageLinksColor: '#ffffff',
	    poweredByTextColor: '#43484d',
	    poweredbyBackgroundColor: '#ffffff',
	    poweredbyDivider: 'none',
	    white: '#ffffff'
	  }
	};
	exports.default = defaulttheme;
	module.exports = exports['default'];

/***/ }),

/***/ 1589:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _emotionTheming = __webpack_require__(59);
	
	__webpack_require__(20);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _Footer = __webpack_require__(25);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _whiteTheme = __webpack_require__(223);
	
	var _whiteTheme2 = _interopRequireDefault(_whiteTheme);
	
	var _darkTheme = __webpack_require__(30);
	
	var _darkTheme2 = _interopRequireDefault(_darkTheme);
	
	var _Header = __webpack_require__(24);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _GalleryHome = __webpack_require__(1129);
	
	var _GalleryHome2 = _interopRequireDefault(_GalleryHome);
	
	var _CloudinaryS3Image = __webpack_require__(23);
	
	var _albumPageStyledComponents = __webpack_require__(1590);
	
	var _albumPageStylesModule = __webpack_require__(1885);
	
	var _albumPageStylesModule2 = _interopRequireDefault(_albumPageStylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-undef, react/prop-types, react/no-danger */
	
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Template);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      isLightBoxOpen: false,
	      activeNodeObject: null
	    }, _this.openLightbox = function (eachImage) {
	      _this.setState({ isLightBoxOpen: true, activeNodeObject: eachImage });
	      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	        document.body.style.overflow = 'hidden';
	      }
	    }, _this.closeLightbox = function () {
	      _this.setState({ isLightBoxOpen: false });
	      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	        document.body.style.overflow = 'unset';
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Template.prototype.render = function render() {
	    var _this2 = this;
	
	    var isLightBoxOpen = this.state.isLightBoxOpen;
	    var _props = this.props,
	        data = _props.data,
	        headerPropsData = _props.headerPropsData,
	        footerProps = _props.footerProps,
	        isBookNowSlotOpened = _props.isBookNowSlotOpened,
	        bookNowModalData = _props.bookNowModalData;
	
	    if (data) {
	      var albumPageData = data.albumPageData.edges;
	      var _albumPageData$0$node = albumPageData[0].node.frontmatter,
	          galleryHeading = _albumPageData$0$node.galleryHeading,
	          date = _albumPageData$0$node.date,
	          albumImagesList = _albumPageData$0$node.albumImagesList,
	          albumSEOData = _albumPageData$0$node.albumSEOData;
	      var title = albumSEOData.title,
	          description = albumSEOData.description,
	          ogTitle = albumSEOData.ogTitle,
	          ogUrl = albumSEOData.ogUrl,
	          ogImage = albumSEOData.ogImage,
	          ogDescription = albumSEOData.ogDescription,
	          ogType = albumSEOData.ogType,
	          ogSiteName = albumSEOData.ogSiteName,
	          twitterTitle = albumSEOData.twitterTitle,
	          twitterUrl = albumSEOData.twitterUrl,
	          twitterSite = albumSEOData.twitterSite,
	          twitterDescription = albumSEOData.twitterDescription,
	          twitterImage = albumSEOData.twitterImage;
	
	
	      return _react2.default.createElement(
	        _emotionTheming.ThemeProvider,
	        { theme: _whiteTheme2.default },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	              'title',
	              null,
	              title
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: description }),
	            _react2.default.createElement('meta', { property: 'og:title', content: ogTitle }),
	            _react2.default.createElement('meta', { property: 'og:url', content: ogUrl }),
	            _react2.default.createElement('meta', { property: 'og:image', content: ogImage }),
	            _react2.default.createElement('meta', { property: 'og:description', content: ogDescription }),
	            _react2.default.createElement('meta', { property: 'og:type', content: ogType }),
	            _react2.default.createElement('meta', { property: 'og:site_name', content: ogSiteName }),
	            _react2.default.createElement('meta', { property: 'twitter:title', content: twitterTitle }),
	            _react2.default.createElement('meta', { name: 'twitter:url', content: twitterUrl }),
	            _react2.default.createElement('meta', { name: 'twitter:site', content: twitterSite }),
	            _react2.default.createElement('meta', {
	              property: 'twitter:description',
	              content: twitterDescription
	            }),
	            _react2.default.createElement('meta', { name: 'twitter:image', content: twitterImage })
	          ),
	          _react2.default.createElement(
	            _albumPageStyledComponents.BlogPageContainer,
	            { className: 'blogImageContainer' },
	            _react2.default.createElement(_Header2.default, {
	              isWhite: true,
	              headerPropsData: headerPropsData,
	              isBookNowSlotOpened: isBookNowSlotOpened,
	              bookNowModalData: bookNowModalData
	            }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: _albumPageStylesModule2.default.GalleryTemplateSection },
	                _react2.default.createElement(
	                  'div',
	                  { className: _albumPageStylesModule2.default.headerSection },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _albumPageStylesModule2.default.headerSectionWrapper },
	                    _react2.default.createElement(
	                      'h1',
	                      { className: _albumPageStylesModule2.default.galleryHeading },
	                      galleryHeading
	                    ),
	                    _react2.default.createElement(
	                      'article',
	                      { className: _albumPageStylesModule2.default.galleryDate },
	                      date
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _ResponsiveContainer2.default,
	                null,
	                _react2.default.createElement(
	                  _albumPageStyledComponents.BodyLayoutContainer,
	                  null,
	                  _react2.default.createElement(
	                    _albumPageStyledComponents.BodyContainer,
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: _albumPageStylesModule2.default.GalleryImageContainer },
	                      albumImagesList.map(function (eachImage) {
	                        return _react2.default.createElement(
	                          _albumPageStyledComponents.ImageItemContainer,
	                          {
	                            key: eachImage.imageUrl,
	                            className: _albumPageStylesModule2.default.ImageContainer,
	                            onClick: function onClick() {
	                              return _this2.openLightbox(eachImage);
	                            }
	                          },
	                          _react2.default.createElement(_CloudinaryS3Image.CloudinaryS3Image, {
	                            src: eachImage.imageUrl,
	                            alt: eachImage.imageAltText,
	                            draggable: false,
	                            configString: 'f_auto,h_175'
	                          })
	                        );
	                      })
	                    ),
	                    isLightBoxOpen ? _react2.default.createElement(_GalleryHome2.default, {
	                      closeLightBox: this.closeLightbox,
	                      currentImageData: this.state.activeNodeObject,
	                      isLightBoxOpen: isLightBoxOpen,
	                      totalImagesData: albumImagesList,
	                      date: date
	                    }) : null
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Footer2.default, _extends({}, footerProps, { theme: _darkTheme2.default.footerSection }))
	        )
	      );
	    }
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	
	// eslint-disable-next-line
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 1590:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BodyContainer = exports.ImageItemContainer = exports.BodyLayoutContainer = exports.BlogPageContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPageContainer = /*#__PURE__*/exports.BlogPageContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1lhi5s60'
	})('font-size:1rem;');
	
	var BodyLayoutContainer = /*#__PURE__*/exports.BodyLayoutContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1lhi5s61'
	})('display:flex;flex-direction:row;flex-wrap:wrap;@media (min-width:320px) and (max-width:425px){width:100%;margin-top:20px;}@media (min-width:426px) and (max-width:767px){width:100%;margin-top:20px;}margin-left:auto;margin-right:auto;');
	
	var ImageItemContainer = /*#__PURE__*/exports.ImageItemContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1lhi5s62'
	})('cursor:pointer;');
	var BodyContainer = /*#__PURE__*/exports.BodyContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1lhi5s63'
	})('padding-bottom:20px;margin-top:4.35em;font-size:1em;width:100%;');

/***/ }),

/***/ 1885:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerSection":"src-templates----albumPageStyles-module---headerSection---3Aruc","headerSectionWrapper":"src-templates----albumPageStyles-module---headerSectionWrapper---3fIUd","ImageContainer":"src-templates----albumPageStyles-module---ImageContainer---37CiU","GalleryTemplateSection":"src-templates----albumPageStyles-module---GalleryTemplateSection---3ovJj","galleryHeading":"src-templates----albumPageStyles-module---galleryHeading---MuEeQ","galleryDate":"src-templates----albumPageStyles-module---galleryDate---295ZK","pathContainer":"src-templates----albumPageStyles-module---pathContainer---3A60V","hrLine":"src-templates----albumPageStyles-module---hrLine---2LIae","GalleryImageContainer":"src-templates----albumPageStyles-module---GalleryImageContainer---1EEGz"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-album-page-template-js-d8fd6164c1e338b50f0f.js